import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import HodViewOne from "../hodviewone/HodViewOne";
import { Select, DatePicker, Form } from "antd";
import moment from "moment";
import { Table, Typography } from "antd";
const { Text } = Typography;
const { Option } = Select;

export default function EmployeeViewReq() {
    const { authData, backUrl } = useContext(AuthContext);
    const [requisitions, setRequisitions] = useState([]);
    const [departmentNames, setDepartmentNames] = useState([]);
    const isMobile = window.innerWidth < 768;
    const [allDepartmentNames, setAllDepartmentNames] = useState([]);
    const [designationNames, setDesignationNames] = useState([]);
    const [organizationNames, setOrganizationNames] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [next, setNext] = useState(null);
    const [prev, setPrev] = useState(null);
    const [particular, setParticular] = useState({
        status: false,
        data: "",
    });

    const [allDesignationNames, setAllDesignationNames] = useState([]);

    const [filters, setFilters] = useState({
        organization: "",
        department: "",
        submission_date_after: "",
        submission_date_before: "",
        status: "",
        designation: "",
    });

    const fetchRequisitions = async (page = 1, customFilters = filters) => {
        if (!authData?.access) return;
        setLoading(true);
        const params = new URLSearchParams({ page });

        if (customFilters.department) params.append("department", customFilters.department);
        if (customFilters.organization) params.append("organisation", customFilters.organization);
        if (customFilters.status) params.append("status", customFilters.status);
        if (customFilters.submission_date_after && customFilters.submission_date_before) {
            params.append("submission_date_after", customFilters.submission_date_after);
            params.append("submission_date_before", customFilters.submission_date_before);
        }
        if (customFilters.designation) params.append("designation", customFilters.designation);

        try {
            const res = await axios.get(`${backUrl}/api/emp/manpowerrequisitions/my_requisitions/?${params}`, {
                headers: { Authorization: `Bearer ${authData.access}` },
            });
            setRequisitions(res.data.results);
            setNext(res.data.next);
            setPrev(res.data.previous);
            setCurrentPage(page);
        } catch (err) {
            console.error("Error fetching requisitions:", err);
            setError("Failed to load requisitions");
        } finally {
            setLoading(false);
        }
    };

    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/organisations/`);
            setOrganizationNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch organizations:", err);
        }
    };

    const fetchDepartments = async (v) => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/departments/?organisation=${v}`);
            setDepartmentNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchAllDepartments = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/departments/`);
            setAllDepartmentNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchDesignations = async (departmentId) => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/designations/?department=${departmentId}`);
            setDesignationNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch designations:", err);
        }
    };

    const fetchAllDesignations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/designations/`);
            setAllDesignationNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch designations:", err);
        }
    };

    useEffect(() => {
        if (authData?.access) {
            fetchRequisitions(1);
            fetchOrganizations();
            fetchAllDepartments();
            fetchAllDesignations();
        }
    }, [authData]);

    useEffect(() => {
        const timer = setTimeout(() => {
            fetchRequisitions(1);
        }, 300);
        return () => clearTimeout(timer);
    }, [filters]);

    const getDepartmentName = (id) => allDepartmentNames.find((d) => d.id === id)?.name || "N/A";
    const getDesignationTitle = (id) => designationNames.find((d) => d.id === id)?.name || "N/A";
    const getOrganizationName = (id) => organizationNames.find((o) => o.id === id)?.name || "N/A";
    const getAllDesignationTitle = (id) => allDesignationNames.find((d) => d.id === id)?.name || "N/A";

    const handleClickOne = (mrfno) => {
        setParticular({ status: true, data: mrfno });
    };

    const getStatusClass = (status) => {
        switch (status) {
            case "Rejected":
                return "red-view";
            case "Sanctioned":
                return "green-view";
            default:
                return "gray-view";
        }
    };

    const columns = [
        {
            title: "MRF Number",
            dataIndex: "mrf_number",
            key: "mrf_number",
            render: (text) => (
                <a style={{ cursor: "pointer", color: "#0e497b" }} onClick={() => handleClickOne(text)}>
                    {text}
                </a>
            ),
        },
        {
            title: "Organization",
            dataIndex: "organisation",
            key: "organisation",
            render: (id) => getOrganizationName(id),
        },
        {
            title: "Department",
            dataIndex: "department",
            key: "department",
            render: (id) => getDepartmentName(id),
        },
        {
            title: "Designation",
            dataIndex: "designation",
            key: "designation",
            render: (id) => getAllDesignationTitle(id),
        },
        {
            title: "Vacancies",
            dataIndex: "no_of_vacancies",
            key: "no_of_vacancies",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => (
                <span className={getStatusClass(status)}>
                    {status === "Manager_Approved"
                        ? "HOD Approved"
                        : status === "Not-Approved"
                            ? "HOD Rejected"
                            : status}
                </span>
            ),
        },
        {
            title: "Date",
            dataIndex: "submission_date",
            key: "submission_date",
        },
    ];

    return (
        <div className="container mt-4">
            {particular.status === false ? (
                <>
                    <center>
                        <h5 className="mb-2">View Requisitions</h5>
                    </center>

                    {isMobile ? (
                        <div className="filters-area">
                            <Form.Item label="Organization">
                                <Select
                                    placeholder="-- Select organization --"
                                    value={filters.organization}
                                    onChange={(value) => {
                                        setFilters({ ...filters, organization: value });
                                        fetchDepartments(value);
                                    }}
                                    allowClear
                                    style={{ width: "200px" }}
                                >
                                    {organizationNames.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item label="Department">
                                <Select
                                    showSearch
                                    placeholder="-- Select Department --"
                                    value={filters.department}
                                    onChange={(value) => {
                                        setFilters({ ...filters, department: value });
                                        fetchDesignations(value);
                                    }}
                                    allowClear
                                    style={{ width: "200px" }}
                                    filterOption={(input, option) =>
                                        option?.children?.toLowerCase().includes(input.toLowerCase())
                                    }
                                >

                                    {departmentNames.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item label="Designation">
                                <Select
                                    showSearch
                                    placeholder="-- Select Designation --"
                                    value={filters.designation}
                                    onChange={(value) => setFilters({ ...filters, designation: value })}
                                    allowClear
                                    style={{ width: "200px" }}
                                    filterOption={(input, option) =>
                                        option?.children?.toLowerCase().includes(input.toLowerCase())
                                    }
                                >

                                    {designationNames.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item label="From">
                                <DatePicker
                                    style={{ width: "100%" }}
                                    value={
                                        filters.submission_date_after
                                            ? moment(filters.submission_date_after, "YYYY-MM-DD")
                                            : null
                                    }
                                    onChange={(date, dateString) =>
                                        setFilters({ ...filters, submission_date_after: dateString })
                                    }
                                    format="YYYY-MM-DD"
                                />
                            </Form.Item>

                            <Form.Item label="To">
                                <DatePicker
                                    style={{ width: "100%" }}
                                    value={
                                        filters.submission_date_before
                                            ? moment(filters.submission_date_before, "YYYY-MM-DD")
                                            : null
                                    }
                                    onChange={(date, dateString) =>
                                        setFilters({ ...filters, submission_date_before: dateString })
                                    }
                                    format="YYYY-MM-DD"
                                />
                            </Form.Item>
                        </div>
                    ) : (
                        <div className="filters-area" >
                            <Form.Item label="Organization">
                                <Select
                                    placeholder="-- Select organization --"
                                    value={filters.organization}
                                    onChange={(value) => {
                                        setFilters({ ...filters, organization: value });
                                        fetchDepartments(value);
                                    }}
                                    allowClear
                                    style={{ width: "200px" }}
                                >
                                    {organizationNames.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item label="Department">
                                <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                        option?.children?.toLowerCase().includes(input.toLowerCase())
                                    }
                                    placeholder="-- Select Department --"
                                    value={filters.department}
                                    onChange={(value) => {
                                        setFilters({ ...filters, department: value });
                                        fetchDesignations(value);
                                    }}
                                    allowClear
                                    style={{ width: "200px" }}
                                >
                                    {departmentNames.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item label="Designation">
                                <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                        option?.children?.toLowerCase().includes(input.toLowerCase())
                                    }
                                    placeholder="-- Select Designation --"
                                    value={filters.designation}
                                    onChange={(value) => setFilters({ ...filters, designation: value })}
                                    allowClear
                                    style={{ width: "200px" }}
                                >
                                    {designationNames.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item label="From">
                                <DatePicker
                                    style={{ width: "100%" }}
                                    value={
                                        filters.submission_date_after
                                            ? moment(filters.submission_date_after, "YYYY-MM-DD")
                                            : null
                                    }
                                    onChange={(date, dateString) =>
                                        setFilters({ ...filters, submission_date_after: dateString })
                                    }
                                    format="YYYY-MM-DD"
                                />
                            </Form.Item>

                            <Form.Item label="To">
                                <DatePicker
                                    style={{ width: "100%" }}
                                    value={
                                        filters.submission_date_before
                                            ? moment(filters.submission_date_before, "YYYY-MM-DD")
                                            : null
                                    }
                                    onChange={(date, dateString) =>
                                        setFilters({ ...filters, submission_date_before: dateString })
                                    }
                                    format="YYYY-MM-DD"
                                />
                            </Form.Item>
                        </div>
                    )}

                    {loading ? (
                        <p>Loading...</p>
                    ) : error ? (
                        <p className="text-danger">{error}</p>
                    ) : (
                        <>
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={requisitions}
                                    rowKey="id"
                                    locale={{ emptyText: <Text type="secondary">No requisitions found.</Text> }}
                                    bordered
                                    pagination={false}
                                    style={{ marginTop: 20 }}
                                    components={{
                                        header: {
                                            cell: (props) => (
                                                <th {...props} style={{ backgroundColor: "#0e497b", color: "#fff" }} />
                                            ),
                                        },
                                    }}
                                />
                            </div>

                            {/* Updated Pagination Section with spacing */}
                            <nav style={{ marginTop: "30px", marginBottom: "40px" }}>
                                <ul className="pagination justify-content-center" style={{ gap: "8px" }}>
                                    <li className={`page-item ${!prev ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => prev && fetchRequisitions(currentPage - 1)}
                                        >
                                            Previous
                                        </button>
                                    </li>
                                    <li className="page-item disabled">
                                        <span className="page-link">Page {currentPage}</span>
                                    </li>
                                    <li className={`page-item ${!next ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => next && fetchRequisitions(currentPage + 1)}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </>
                    )}
                </>
            ) : (
                <>
                    <HodViewOne data={particular.data} />
                </>
            )}
        </div>
    );
}
